<template>
  <div class="kd-action-buttons">
    <kd-button
      :text="GET_TEXT('cartButtonWithSleeveText')"
      :icon="require('../assets/images/icons/shopping-cart-white-flipped.svg')"
      style="margin-bottom: 10px; background-color: #00a4dd;"
      size="big"
      type="primary"
      @click.native="addToCartWithSleeveClicked"
    ></kd-button>
    <kd-button
      :text="GET_TEXT('cartButtonText')"
      :icon="require('../assets/images/icons/shopping-cart-white-flipped.svg')"
      size="big"
      type="primary"
      @click.native="addToCartClicked"
    ></kd-button>
    <kd-button
      :text="GET_TEXT('wishlistButtonText')"
      :icon="require('../assets/images/icons/like-999999.svg')"
      size="big"
      type="link"
      @click.native="addToWishlistClicked"
    ></kd-button>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import * as log from 'loglevel';
import KdButton from '@/components/KdButton.vue';

import {
  CARD_DATA_AS_JSON_STRING,
  GET_TEXT,
} from '@/store/getter-types';

import {
  SET_KARTENDESIGNER_VISIBILITY,
  SET_WAITING_FOR_PDF,
  SET_PDF_URL,
  SET_CART_IMAGE_URL,
} from '@/store/mutation-types';

import {
  REQUEST_PDF,
} from '@/store/action-types';

export default {
  computed: {
    ...mapGetters([
      CARD_DATA_AS_JSON_STRING,
      GET_TEXT,
    ]),
  },
  methods: {
    ...mapMutations([
      SET_KARTENDESIGNER_VISIBILITY,
      SET_WAITING_FOR_PDF,
      SET_PDF_URL,
      SET_CART_IMAGE_URL,
    ]),
    ...mapActions([
      REQUEST_PDF,
    ]),
    openPopupWithPdfUrl(url) { // just for development
      window.open(`${process.env.VUE_APP_IMAGE_SERVER}${url}`);
    },
    addToCartWithSleeveClicked() {
      this.SET_WAITING_FOR_PDF(true);
      this.REQUEST_PDF().then((resp) => {
        log.debug('Got PDF response!!', resp);
        this.SET_PDF_URL(resp.data.pdfUrl);
        this.SET_CART_IMAGE_URL(resp.data.cartImageUrl);
        if (window.kartendesigner && window.kartendesigner.onAddToCartCategoryRedirect) {
          window.kartendesigner.onAddToCartCategoryRedirect(this.CARD_DATA_AS_JSON_STRING);
        } else {
          log.warn('Could not call function "window.kartendesigner.onAddToCartCategoryRedirect", because it does not exist.');
          this.openPopupWithPdfUrl(resp.data.pdfUrl);
        }
        this.SET_WAITING_FOR_PDF(false);
        this.SET_KARTENDESIGNER_VISIBILITY(false);
      }).catch((err) => {
        log.error('There was an error requesting the PDF when putting it into the basket. Maybe the server is down.');
        this.SET_WAITING_FOR_PDF(false);
        alert('Leider konnten wir die Grußkarte nicht zu Ihrem Warenkorb hinzufügen. Bitte versuchen Sie es später erneut. Wir bitten um Entschuldigung.');
      });
    },
    addToCartClicked() {
      this.SET_WAITING_FOR_PDF(true);
      this.REQUEST_PDF().then((resp) => {
        log.debug('Got PDF response!!', resp);
        this.SET_PDF_URL(resp.data.pdfUrl);
        this.SET_CART_IMAGE_URL(resp.data.cartImageUrl);
        if (window.kartendesigner && window.kartendesigner.onAddToCart) {
          window.kartendesigner.onAddToCart(this.CARD_DATA_AS_JSON_STRING);
        } else {
          log.warn('Could not call function "window.kartendesigner.onAddToCart", because it does not exist.');
          this.openPopupWithPdfUrl(resp.data.pdfUrl);
        }
        this.SET_WAITING_FOR_PDF(false);
        this.SET_KARTENDESIGNER_VISIBILITY(false);
      }).catch((err) => {
        log.error('There was an error requesting the PDF when putting it into the basket. Maybe the server is down.');
        this.SET_WAITING_FOR_PDF(false);
        alert('Leider konnten wir die Grußkarte nicht zu Ihrem Warenkorb hinzufügen. Bitte versuchen Sie es später erneut. Wir bitten um Entschuldigung.');
      });
    },
    addToWishlistClicked() {
      this.SET_WAITING_FOR_PDF(true);
      this.REQUEST_PDF().then((resp) => {
        log.debug('Got PDF response!!', resp);
        this.SET_PDF_URL(resp.data.pdfUrl);
        this.SET_CART_IMAGE_URL(resp.data.cartImageUrl);
        
        if (window.kartendesigner && window.kartendesigner.onAddToWishlist) {
          window.kartendesigner.onAddToWishlist(this.CARD_DATA_AS_JSON_STRING);
        } else {
          log.warn('Could not call function "window.kartendesigner.onAddToWishlist", because it does not exist.');
          this.openPopupWithPdfUrl(resp.data.pdfUrl);
        }
        this.SET_WAITING_FOR_PDF(false);
        this.SET_KARTENDESIGNER_VISIBILITY(false);
      }).catch((err) => {
        log.error('There was an error requesting the PDF when putting it into the wishlist. Maybe the server is down.');
        this.SET_WAITING_FOR_PDF(false);
        alert('Leider konnten wir die Grußkarte nicht zu Ihrer Wunschliste hinzufügen. Bitte versuchen Sie es später erneut. Wir bitten um Entschuldigung.');
      });
    },
  },
  components: {
    KdButton,
  },
};
</script>

<style lang="scss">
  .kd-action-buttons {
    position: absolute;
    // hach / oppermann-specific: the chat widget is overlaying the buttons, so we need to move them a bit up
    // bottom: 12px;
    bottom: 40px;
    right: 12px;
  }
</style>
